import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import connectionService from '../services/Connection';
import {  useSetState } from '../hooks';
import DashboardFilterModelForm from './forms/DashboardFilterModelForm';

export default function TopFilter({ onFilterChange, extraParams, comboTypes = ['Location', 'EquipmentType'] }) {
	const topFilterList = useSelector(state => state.topFilterList);
	const location = useLocation();
	const [state, setState] = useSetState({
			data: topFilterList?.data ?? {},
			combos: topFilterList?.combos ?? {}
		}
	);
	const fromModality = location.pathname === '/modalitydashboard';

	

	const fetchData = useCallback(() => {
		const combosToLoad = comboTypes.map((item) => { return { "type": item, "loaded": true } });
		const formData = new FormData();
		formData.append('action', 'load');
		formData.append('id', 0);
		formData.append('comboTypes', JSON.stringify(combosToLoad));

		fetch(connectionService.DashBoardEquipment, {
			method: 'POST',
			body: formData,
		})
			.then((res) => res.json())
			.then(({ success, data, combos }) => {
				if (success) {
					setState({ combos, data })
				}
				else {
					throw new Error('Failed to fetch data from the server.')
				}
			})
			.catch((error) => { });
	}, [onFilterChange, comboTypes]);


	useEffect(fetchData, []);


	const handleOnFilterChange = useCallback((values) => {
		if (typeof onFilterChange === 'function') {
			onFilterChange(values);
		}

	}, []);

	if (!topFilterList) { return null; }
	return (
		<Grid container spacing={1} sx={{ marginBottom: 3 }}>
			<Grid size={12}>
				<DashboardFilterModelForm
					containerProps={{ elevation: 0 }}
					activeRecord={{
						record: state.data,
						combos: state.combos,
						isModalityDashboard: location.pathname === '/modalitydashboard'
					}}
					initialValues={extraParams}
					onSubmit={handleOnFilterChange}
					hideCancel
					hideSubmit
				/>
			</Grid>
		</Grid>
	);
}